<template>
    <div class="OrderResourceAllocation">
        <div class="summary_bag">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <div class="summary_complete_bag">
                    <el-form :inline="true" label-width="120px" ref="selectForm" :model="selectForm">
                        <el-form-item label="买家账号等级" prop="value" v-if="activeName === 'first'">
                            <el-select
                                clearable
                                v-model="selectForm.BuyerAccountLevel"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="(item, index) in List"
                                    :key="index"
                                    :label="item.gradeName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="信用卡账号等级" prop="value" v-else-if="activeName === 'second'">
                            <el-select
                                clearable
                                v-model="selectForm.CreditCardLevel"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="(item, index) in List2"
                                    :key="index"
                                    :label="item.gradeName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="买家地址等级" prop="value" v-else-if="activeName === 'third'">
                            <el-select
                                clearable
                                v-model="selectForm.BuyerAddressClass"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="(item, index) in List3"
                                    :key="index"
                                    :label="item.gradeName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="下单IP地址等级" prop="value" v-else-if="activeName === 'fourth'">
                            <el-select
                                clearable
                                v-model="selectForm.SingleIPLevel"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="(item, index) in List4"
                                    :key="index"
                                    :label="item.gradeName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="账号状态" prop="value">
                            <el-select clearable  v-model="selectForm.AccountStatus">
                                <!-- <el-option label="全部" :value="4"></el-option> -->
                                <el-option label="活跃中" :value="1"></el-option>
                                <el-option label="已封禁" :value="0"></el-option>
                                <el-option label="待回收" :value="2"></el-option>
                                <el-option label="已回收" :value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="领用状态" prop="isTranslation">
                            <el-select clearable  v-model="selectForm.RecipientsState">
                                <!-- <el-option label="全部" :value="2"></el-option> -->
                                <el-option label="已领用" :value="1"></el-option>
                                <el-option label="未领用" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="isTranslation">
                            <span slot="label">
                                <span class="span-box">
                                    <p>国家</p>
                                    <el-tooltip style="diaplay:inline" effect="dark" content="此国家为下单账号所属国家，及该国家账号还有多少" placement="top">
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </span>
                            </span>
                            <el-radio-group v-model="selectForm.country">
                                <el-row type="flex">
                                    <el-radio label="US">美国 ( {{ countryList.US }} )</el-radio>
                                    <el-radio label="CA">加拿大 ( {{ countryList.CA }} )</el-radio>
                                    <el-radio label="MX">墨西哥 ( {{ countryList.MX }} )</el-radio>
                                </el-row>
                                <el-row type="flex" style="margin: 10px 0">
                                    <el-radio label="GB">英国 ( {{ countryList.GB }} )</el-radio>
                                    <el-radio label="DE">德国 ( {{ countryList.DE }} )</el-radio>
                                    <el-radio label="FR">法国 ( {{ countryList.FR }} )</el-radio>
                                    <el-radio label="IT">意大利 ( {{ countryList.IT }} )</el-radio>
                                    <el-radio label="ES">西班牙 ( {{ countryList.ES }} )</el-radio>
                                    <el-radio label="NL">荷兰 ( {{ countryList.NL }} )</el-radio>
                                    <el-radio label="SE">瑞典 ( {{ countryList.SE }} )</el-radio>
                                    <el-radio label="PL">波兰 ( {{ countryList.PL }} )</el-radio>
                                    <el-radio label="SA">沙特阿拉伯 ( {{ countryList.SA }} )</el-radio>
                                    <el-radio label="AE">阿联酋 ( {{ countryList.AE }} )</el-radio>
                                </el-row>
                                <el-row type="flex">
                                    <el-radio label="JP">日本 ( {{ countryList.JP }} )</el-radio>
                                    <el-radio label="AU">澳大利亚 ( {{ countryList.AU }} )</el-radio>
                                    <el-radio label="SG">新加坡 ( {{ countryList.SG }} )</el-radio>
                                </el-row>
                                <!-- <el-radio v-for="(item,index) in country" :key="index" :label="item.value">{{item.name}}</el-radio> -->
                            </el-radio-group>
                        </el-form-item><br>
                        <el-form-item label="时间筛选类型" prop="isTranslation">
                            <el-radio-group v-model="selectForm.timeType">
                                <el-radio :label="2">注册时间</el-radio>
                                <el-radio :label="1">添加时间</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="开始日期" prop="startTime">
                            <el-date-picker
                                v-model="selectForm.startTime"
                                align="right"
                                type="datetime"
							    :picker-options="pickerOptions"
                                placeholder="选择开始日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width:200px;"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="结束日期" prop="endTime">
                            <el-date-picker
                                v-model="selectForm.endTime"
                                align="right"
                                type="datetime"
							    :picker-options="pickerOptions"
                                placeholder="选择结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                style="width:200px;"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item label=" " prop="input">
                            <el-input
                                class="custom-input"
                                v-model="selectForm.input"
                                placeholder="全字段搜索"
                                style="width:320px;"
                                clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" v-if="activeName === 'first'" @click="Search('1')">搜索</el-button>
                            <el-button type="primary" v-else-if="activeName === 'second'" @click="Search('2')">搜索</el-button>
                            <el-button type="primary" v-else-if="activeName === 'third'" @click="Search('3')">搜索</el-button>
                            <el-button type="primary" v-else-if="activeName === 'fourth'" @click="Search('4')">搜索</el-button>
                            <el-button type="primary" v-if="activeName === 'first'" @click="searchReset('1')">重置</el-button>
                            <el-button type="primary" v-else-if="activeName === 'second'" @click="searchReset('2')">重置</el-button>
                            <el-button type="primary" v-else-if="activeName === 'third'" @click="searchReset('3')">重置</el-button>
                            <el-button type="primary" v-else-if="activeName === 'fourth'" @click="searchReset('4')">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <el-tab-pane label="添加买家账号" name="first">
                    <!-- 买家账号审批流程设置-->
                    <div class="summary_pagenum1">
                        <el-button type="text" @click="handleResources('first')">买家账号资源</el-button>
                        <div>
                            <el-button type="text" @click="edit('1')">添加买家账号</el-button>
                            <el-button type="text" @click="handleImport('first')">导入买家账号</el-button>
                        </div>
                    </div>
                    <div class="summary_content">
                        <div class="summary_list">
                            <el-table :data="summarylist4" style="width: 100%" v-loading="load_data" element-loading-text="拼命加载中"
                                border :header-cell-style="iscenter" stripe>
                                <el-table-column label="序号" prop="id" width="80" align="center"></el-table-column>
                                <el-table-column prop="buyerAccount" label="买家账号" align="center"></el-table-column>
                                <el-table-column prop="emailPassword" label="邮箱密码" align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="recoveryEmail"
                                    label="辅助邮箱"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    prop="registrationTime"
                                    label="注册时间"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    prop="buyerName"
                                    label="买家名称"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="gradeName"
                                    label="买家账号等级"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="country"
                                    label="国家"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="账号状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.buyerAccountAccountStatus === 1" style="color:green">活跃中</p>
                                        <p v-else-if="scope.row.buyerAccountAccountStatus === 0" style="color:red">已封禁</p>
                                        <p v-else-if="scope.row.buyerAccountAccountStatus === 2" style="color:#feba07">待回收</p>
                                        <p v-else-if="scope.row.buyerAccountAccountStatus === 3">已回收</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="采购状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.buyerAccountPurchaseStatus === 1" style="color:green">已购买</p>
                                        <p v-else-if="scope.row.buyerAccountPurchaseStatus === 0" style="color:#feba07">未购买</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="领用状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.buyerAccountRequisitionStatus === 1">已领用</p>
                                        <p v-else-if="scope.row.buyerAccountRequisitionStatus === 0" style="color:#feba07">未领用</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="createTime"
                                    label="添加时间"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="roleNameList"
                                    label="使用人"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="ziName"
                                    label="操作"
                                    align="center"
                                    width="210px"
                                >
                                    <template slot-scope="scope">
                                        <el-button type="danger" @click="delAccount(scope.row)">删除</el-button>
                                        <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
                                        <el-button type="primary" :disabled="scope.row.buyerAccountAccountStatus === 3 ? true : false" @click="handleBack('first', scope.row)">收回</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <el-dialog title="添加买家账号" :visible.sync="EditReimbursement" width="50%" class="dialog">
                        <el-form :model="form" class="form">
                            <el-form-item label="买家账号等级" :label-width="formLabelWidth">
                                <el-select
                                    clearable
                                    v-model="form.BuyerAccountLevel"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="(item, index) in List"
                                        :key="index"
                                        :label="item.gradeName"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="国家" :label-width="formLabelWidth">
                                <el-select
                                    clearable
                                    v-model="form.country"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="(item, index) in country"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.Referred"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-row type="flex">
                                <el-form-item label="买家账号" :label-width="formLabelWidth">
                                    <el-input v-model="form.BuyersAccount"></el-input>
                                </el-form-item>
                                <el-form-item label="邮箱密码" :label-width="formLabelWidth">
                                    <el-input v-model="form.YourPassword"></el-input>
                                </el-form-item>
                                <el-form-item label="辅助邮箱" :label-width="formLabelWidth">
                                    <el-input v-model="form.AuxiliaryEmail"></el-input>
                                </el-form-item>
                            </el-row>
                            <el-row type="flex">
                                <el-form-item label="买家名称" :label-width="formLabelWidth">
                                    <el-input v-model="form.BuyerName"></el-input>
                                </el-form-item>
                                <el-form-item label="注册时间" :label-width="formLabelWidth">
                                    <el-date-picker
                                        @change="RegistrationTime"
                                        v-model="form.RegistrationTime"
                                        type="date"
                                        placeholder="选择注册时间">
                                        </el-date-picker>
                                </el-form-item>
                            </el-row>
                            <el-form-item label="报账金额" :label-width="formLabelWidth">
                                <el-input v-model="form.ReimbursementAmount"></el-input> 元
                            </el-form-item>
                            <el-form-item label="上传凭证" :label-width="formLabelWidth">
                                <el-upload
                                    ref="upload"
                                    :action="action"
                                    list-type="picture-card"
                                    :on-success="handleAvatarSuccess"
                                    :on-preview="handlePictureCardPreview"
                                    :on-remove="handleRemove"
                                    :headers="customHeaders"
                                    :file-list="arr"
                                >
                                    <i class="el-icon-plus" style="color: #0724ef;"></i>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="EditbankCard" v-if="form.status === '0'">立即添加</el-button>
                            <el-button type="primary" @click="updateAccount" v-else-if="form.status === '1'">保存修改</el-button>
                        </div>
                    </el-dialog>
                </el-tab-pane>
                <el-tab-pane label="添加信用卡账号" name="second">
                    <div class="summary_pagenum">
                        <el-button type="text" @click="edit1('1')">添加信用卡账号</el-button>
                        <el-button type="text" @click="handleImport('second')">导入信用卡账号</el-button>
                    </div>
                    <div class="summary_content">
                        <div class="summary_list">
                            <el-table
                                :data="summarylist1"
                                style="width: 100%"
                                v-loading="load_data"
                                element-loading-text="拼命加载中"
                                border
                                :header-cell-style="iscenter"
                                stripe
                            >
                                <el-table-column
                                    label="序号"
                                    prop="id"
                                    align="center"
                                    width="80"
                                ></el-table-column>
                                <el-table-column
                                    label="信用卡账号"
                                    align="center"
                                    prop="creditCardAccount"
                                >
                                </el-table-column>
                                <el-table-column prop="expirationDate" label="有效期" align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="securityCode"
                                    label="安全码"
                                    align="center"
                                ></el-table-column>
                                <!-- <el-table-column
                                    prop="sku"
                                    label="生成时间"
                                    align="center"
                                ></el-table-column> -->
                                <el-table-column
                                    prop="gradeName"
                                    label="信用卡账号等级"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="country"
                                    label="国家"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="账号状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.creditCardAccountStatus === 1" style="color:green">活跃中</p>
                                        <p v-else-if="scope.row.creditCardAccountStatus === 0" style="color:red">已封禁</p>
                                        <p v-else-if="scope.row.creditCardAccountStatus === 2" style="color:#feba07">待回收</p>
                                        <p v-else-if="scope.row.creditCardAccountStatus === 3">已回收</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="采购状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.creditCardPurchaseStatus === 1" style="color:green">已购买</p>
                                        <p v-else-if="scope.row.creditCardPurchaseStatus === 0" style="color:#feba07">未购买</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="领用状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.creditCardReceiptStatus === 1">已领用</p>
                                        <p v-else-if="scope.row.creditCardReceiptStatus === 0" style="color:#feba07">未领用</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="createTime"
                                    label="添加时间"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="roleNameList"
                                    label="使用人"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    align="center"
                                    width="210px"
                                >
                                    <template slot-scope="scope">
                                        <el-button type="danger" @click="delCreditCardList(scope.row)">删除</el-button>
                                        <el-button type="primary" @click="edit1(scope.row)">编辑</el-button>
                                        <el-button type="primary" :disabled="scope.row.creditCardAccountStatus === 3 ? true : false"  @click="handleBack('second', scope.row)">收回</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <el-dialog title="添加信用卡账号" :visible.sync="EditReimbursement1" width="50%" class="dialog">
                        <el-form :model="form1" class="form">
                            <el-form-item label="信用卡账号等级" :label-width="formLabelWidth">
                                <el-select
                                    clearable
                                    v-model="form1.CreditCardLevel"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="(item, index) in List2"
                                        :key="index"
                                        :label="item.gradeName"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="国家" :label-width="formLabelWidth">
                                <el-select
                                    clearable
                                    v-model="form1.country"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="(item, index) in country"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.Referred"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-row type="flex">
                                <el-form-item label="信用卡账号" :label-width="formLabelWidth">
                                    <el-input v-model="form1.CreditCardNumber"></el-input>
                                </el-form-item>
                                <el-form-item label="有效期" :label-width="formLabelWidth">
                                    <el-date-picker
                                        @change="costReconciliation"
                                        v-model="form1.periodValidity"
                                        type="date"
                                        placeholder="选择注册时间">
                                        </el-date-picker>
                                </el-form-item>
                            </el-row>
                            <el-form-item label="安全码" :label-width="formLabelWidth">
                                <el-input v-model="form1.SecurityCode" maxlength="3"></el-input>
                            </el-form-item>
                            <el-form-item label="报账金额" :label-width="formLabelWidth">
                                <el-input v-model="form1.ReimbursementAmount"></el-input> 元
                            </el-form-item>
                            <el-form-item label="上传凭证" :label-width="formLabelWidth">
                                <el-upload
                                    ref="upload"
                                    :action="action"
                                    list-type="picture-card"
                                    :on-success="handleAvatarSuccess1"
                                    :on-preview="handlePictureCardPreview"
                                    :on-remove="handleRemove1"
                                    :headers="customHeaders"
                                    :file-list="arr1"
                                >
                                    <i class="el-icon-plus" style="color: #0724ef;"></i>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="EditbankCard1" v-if="form1.status === '0'">立即添加</el-button>
                            <el-button type="primary" @click="updateAccount1" v-else-if="form1.status === '1'">保存修改</el-button>
                        </div>
                    </el-dialog>
                </el-tab-pane>
                <el-tab-pane label="添加买家地址" name="third">
                    <div class="summary_pagenum">
                        <el-button type="text" @click="edit2('1')">添加买家地址</el-button>
                        <el-button type="text" @click="handleImport('third')">导入买家地址</el-button>
                    </div>
                    <div class="summary_content">
                        <div class="summary_list">
                            <el-table
                                :data="summarylist2"
                                style="width: 100%"
                                v-loading="load_data"
                                element-loading-text="拼命加载中"
                                border
                                :header-cell-style="iscenter"
                                stripe
                            >
                                <el-table-column
                                    label="序号"
                                    prop="id"
                                    align="center"
                                    width="80"
                                ></el-table-column>
                                <el-table-column
                                    label="国家"
                                    align="center"
                                    prop="country"
                                >
                                </el-table-column>
                                <el-table-column prop="recipient" label="收件人" align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="stateOrRegion"
                                    label="州/省"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    prop="city"
                                    label="城市"
                                    align="center"
                                ></el-table-column>
                                <!-- <el-table-column
                                    prop="productPrice"
                                    label="生成时间"
                                    align="center"
                                >
                                </el-table-column> -->
                                <el-table-column
                                    prop="gradeName"
                                    label="买家地址等级"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="账号状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.buyerAddressAccountStatus === 1" style="color:green">活跃中</p>
                                        <p v-else-if="scope.row.buyerAddressAccountStatus === 0" style="color:red">已封禁</p>
                                        <p v-else-if="scope.row.buyerAddressAccountStatus === 2" style="color:#feba07">待回收</p>
                                        <p v-else-if="scope.row.buyerAddressAccountStatus === 3">已回收</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="领用状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.buyerAddressReceiptStatus === 1">已领用</p>
                                        <p v-else-if="scope.row.buyerAddressReceiptStatus === 0" style="color:#feba07">未领用</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="createTime"
                                    label="添加时间"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="使用人"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-for="(item,index) in scope.row.roleNameList" :key="index">{{ item }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    align="center"
                                    width="210px"
                                >
                                    <template slot-scope="scope">
                                        <el-button type="danger" @click="delBuyerAddressList(scope.row)">删除</el-button>
                                        <el-button type="primary" @click="edit2(scope.row)">编辑</el-button>
                                        <el-button type="primary" :disabled="scope.row.buyerAddressAccountStatus === 3 ? true : false"  @click="handleBack('third', scope.row)">收回</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <el-dialog title="添加买家地址" :visible.sync="EditReimbursement2" width="55%" class="dialog">
                        <el-form :model="form2" class="form">
                            <el-form-item label="买家地址等级" :label-width="formLabelWidth">
                                <el-select
                                    clearable
                                    v-model="form2.BuyerAddressClass"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="(item, index) in List3"
                                        :key="index"
                                        :label="item.gradeName"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-row type="flex">
                                <el-form-item label="国家" :label-width="formLabelWidth">
                                    <el-select v-model="form2.country" clearable>
                                        <el-option
                                            v-for="(item, index) in country"
                                            :key="index"
                                            :label="item.name"
                                            :value="item.Referred"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="州/省" label-width="50px">
                                    <el-input v-model="form2.province" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item label="城市" label-width="50px">
                                    <el-input v-model="form2.city" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item label="县" label-width="40px">
                                    <el-input v-model="form2.county" placeholder=""></el-input>
                                </el-form-item>
                            </el-row>
                            <el-row type="flex">
                                <el-form-item label="收件人" :label-width="formLabelWidth">
                                    <el-input v-model="form2.recipient" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item label="邮编" label-width="50px">
                                    <el-input v-model="form2.email" placeholder=""></el-input>
                                </el-form-item>
                                <el-form-item label="电话" label-width="50px">
                                    <el-input v-model="form2.phone" placeholder=""></el-input>
                                </el-form-item>
                            </el-row>
                            <el-form-item label="地址1" :label-width="formLabelWidth">
                                <el-input v-model="form2.Address1" placeholder="" style="width:73%"></el-input>
                            </el-form-item>
                            <el-form-item label="地址2" :label-width="formLabelWidth">
                                <el-input v-model="form2.Address2" placeholder="" style="width:73%"></el-input>
                            </el-form-item>
                            <el-form-item label="地址3" :label-width="formLabelWidth">
                                <el-input v-model="form2.Address3" placeholder="" style="width:73%"></el-input>
                            </el-form-item>
                            <el-form-item label="报账金额" :label-width="formLabelWidth">
                                <el-input v-model="form2.ReimbursementAmount"></el-input> 元
                            </el-form-item>
                            <el-form-item label="上传凭证" :label-width="formLabelWidth">
                                <el-upload
                                    ref="upload"
                                    :action="action"
                                    list-type="picture-card"
                                    :on-success="handleAvatarSuccess2"
                                    :on-preview="handlePictureCardPreview"
                                    :on-remove="handleRemove2"
                                    :headers="customHeaders"
                                    :file-list="arr2"
                                >
                                    <i class="el-icon-plus" style="color: #0724ef;"></i>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="EditbankCard2" v-if="form2.status === '0'">立即添加</el-button>
                            <el-button type="primary" @click="updateAccount2" v-else-if="form2.status === '1'">保存修改</el-button>
                        </div>
                    </el-dialog>
                </el-tab-pane>
                <el-tab-pane label="添加下单IP地址" name="fourth">
                    <div class="summary_pagenum1">
                        <el-button type="text" @click="handleResources('fourth')">下单IP地址资源</el-button>
                        <div>
                            <el-button type="text" @click="edit3('1')">添加下单IP地址</el-button>
                            <el-button type="text" @click="handleImport('fourth')">导入下单IP地址</el-button>
                        </div>
                    </div>
                    <div class="summary_content">
                        <div class="summary_list">
                            <el-table
                                :data="summarylist3"
                                style="width: 100%"
                                v-loading="load_data"
                                element-loading-text="拼命加载中"
                                border
                                :header-cell-style="iscenter"
                                stripe
                            >
                                <el-table-column
                                    label="序号"
                                    prop="id"
                                    width="80"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    label="服务器种类"
                                    align="center"
                                    prop="serverType"
                                >
                                </el-table-column>
                                <el-table-column prop="purchaseAccount" label="购买账号" align="center">
                                </el-table-column>
                                <el-table-column
                                    prop="purchasePassword"
                                    label="购买密码"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    prop="expirationDate"
                                    label="到期时间"
                                    align="center"
                                ></el-table-column>
                                <el-table-column
                                    prop="gradeName"
                                    label="下单IP地址等级"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="country"
                                    label="国家"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="address"
                                    label="IP地址"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="password"
                                    label="IP密码"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="账号状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.orderIPAccountStatus === 1" style="color:green">活跃中</p>
                                        <p v-else-if="scope.row.orderIPAccountStatus === 0" style="color:red">已封禁</p>
                                        <p v-else-if="scope.row.orderIPAccountStatus === 2" style="color:#feba07">待回收</p>
                                        <p v-else-if="scope.row.orderIPAccountStatus === 3">已回收</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="领用状态"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.orderIPReceiptStatus === 1">已领用</p>
                                        <p v-else-if="scope.row.orderIPReceiptStatus === 0" style="color:#feba07">未领用</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="createTime"
                                    label="添加时间"
                                    align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="使用人"
                                    align="center"
                                >
                                    <template slot-scope="scope">
                                        <p v-for="(item,index) in scope.row.roleNameList" :key="index">{{ item }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    align="center"
                                    width="210px"
                                >
                                    <template slot-scope="scope">
                                        <el-button type="danger" @click="delIPAddressList(scope.row)">删除</el-button>
                                        <el-button type="primary" @click="edit3(scope.row)">编辑</el-button>
                                        <el-button type="primary" :disabled="scope.row.orderIPAccountStatus === 3 ? true : false"  @click="handleBack('fourth', scope.row)">收回</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <el-dialog title="添加下单IP地址" :visible.sync="EditReimbursement3" width="50%" class="dialog">
                        <el-form :model="form3" class="form">
                            <el-form-item label="下单IP地址等级" :label-width="formLabelWidth">
                                <el-select
                                    clearable
                                    v-model="form3.SingleIPlevel"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="(item, index) in List4"
                                        :key="index"
                                        :label="item.gradeName"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="国家" :label-width="formLabelWidth">
                                <el-select
                                    clearable
                                    v-model="form3.country"
                                    placeholder="请选择"
                                >
                                    <el-option
                                        v-for="(item, index) in country"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.Referred"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-row type="flex">
                                <el-form-item label="服务器种类" :label-width="formLabelWidth">
                                    <el-input v-model="form3.ServerType" placeholder=""></el-input>
                                    <!-- <el-select v-model="form3.ServerType" filterable placeholder="请选择">
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select> -->
                                </el-form-item>
                                <el-form-item label="购买账号" :label-width="formLabelWidth">
                                    <el-input v-model="form3.PurchaseAccount"></el-input>
                                </el-form-item>
                                <el-form-item label="购买密码" :label-width="formLabelWidth">
                                    <el-input v-model="form3.BuyPassword"></el-input>
                                </el-form-item>
                            </el-row>
                            <el-row type="flex">
                                <el-form-item label="到期时间" :label-width="formLabelWidth">
                                    <el-date-picker
                                        @change="DueTime"
                                        v-model="form3.DueTime"
                                        type="date"
                                        placeholder="选择到期时间">
                                        </el-date-picker>
                                </el-form-item>
                                <el-form-item label="IP地址" :label-width="formLabelWidth">
                                    <el-input v-model="form3.IPAddress"></el-input>
                                </el-form-item>
                                <el-form-item label="IP密码" :label-width="formLabelWidth">
                                    <el-input v-model="form3.IPPassword"></el-input>
                                </el-form-item>
                            </el-row>
                            <el-form-item label="报账金额" :label-width="formLabelWidth">
                                <el-input v-model="form3.ReimbursementAmount"></el-input> 元
                            </el-form-item>
                            <el-form-item label="上传凭证" :label-width="formLabelWidth">
                                <el-upload
                                    ref="upload"
                                    :action="action"
                                    list-type="picture-card"
                                    :on-success="handleAvatarSuccess3"
                                    :on-preview="handlePictureCardPreview"
                                    :on-remove="handleRemove3"
                                    :headers="customHeaders"
                                    :file-list="arr3"
                                >
                                    <i class="el-icon-plus" style="color: #0724ef;"></i>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="EditbankCard3" v-if="form3.status === '0'">立即添加</el-button>
                            <el-button type="primary" @click="updateAccount3" v-else-if="form3.status === '1'">保存修改</el-button>
                        </div>
                    </el-dialog>
                </el-tab-pane>
            </el-tabs>
            <div class="summary_pagenum_block">
                <div class="block">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
					    :page-size="size"
                        @size-change="handleSizeChange"
                        :page-sizes="[10, 20, 50, 100]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="50%">
            <div>
                <el-row type="flex" style="margin-bottom:15px" align="middle">
                    <upload-excel-component :on-success="handleSuccess" />
                    <el-button size="mini" @click="downloadTemplate" style="margin-left:20px">下载模板</el-button>
                    <div class="tips-box" style="margin-left:20px" v-if="activeName === 'first' || activeName === 'fourth'">日期需按此格式填写：2021.08.31</div>
                    <div class="tips-box" style="margin-left:20px" v-else-if="activeName === 'second'">日期需按此格式填写：2021.08</div>
                </el-row>
                <label>{{ fileName }}</label>
                <div class="tips-box">注意：为了保证导入数据有效，此处导入的表格格式必须严格按照模板填写</div>
                <el-form ref="form" :model="form4" label-width="64px" style="margin-top:15px">
                    <el-form-item label="买家账号等级" label-width="110px" v-if="title === 'first'">
                        <el-select
                            clearable
                            v-model="form4.BuyerAccountLevel"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="(item, index) in List"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="信用卡账号等级" label-width="110px" v-else-if="title === 'second'">
                        <el-select
                            clearable
                            v-model="form4.CreditCardLevel"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="(item, index) in List2"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="买家地址等级" label-width="110px" v-else-if="title === 'third'">
                        <el-select
                            clearable
                            v-model="form4.BuyerAddressClass"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="(item, index) in List3"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="下单IP地址等级" label-width="110px" v-else-if="title === 'fourth'">
                        <el-select
                            clearable
                            v-model="form4.SingleIPlevel"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="(item, index) in List4"
                                :key="index"
                                :label="item.gradeName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="国家" label-width="110px">
                        <el-select
                            clearable
                            v-model="form4.country"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="(item, index) in country"
                                :key="index"
                                :label="item.name"
                                :value="item.Referred"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="报账金额" label-width="110px">
                        <el-input v-model="form4.ReimbursementAmount" style="width:200px"></el-input> 元
                    </el-form-item>
                    <el-form-item label="上传凭证" label-width="110px">
                        <el-upload
                            ref="upload"
                            :action="action"
                            list-type="picture-card"
                            :on-success="handleAvatarSuccess4"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove4"
                            :headers="customHeaders"
                        >
                            <i class="el-icon-plus" style="color: #0724ef;"></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="ImportBuyerAccount(dialogTitle)">确定导入</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="dialogTitle1" :visible.sync="dialogFormVisible" append-to-body width="35%">
            <el-form :model="form">
                <el-form-item label>
                    <div v-for="(item, index) in blue_point" :key="index">
                        <el-row type="flex" align="middle">
                            <label>链接：</label>
                            <el-input placeholder="请输入内容" v-model="item.resourceLink" style="width:73%">
                            </el-input>
                            <el-button style="background:#DCDFE6">访问链接</el-button>
                            <el-button
                                v-show="item.type"
                                style="height: 28.13px;margin-left:0"
                                type="danger"
                                @click="edit_blue_del(item, index)"
                                icon="el-icon-close"
                            ></el-button>
                        </el-row>
                        <el-row type="flex" style="margin-bottom:10px">
                            <label>备注：</label>
                            <el-input type="textarea" v-model="item.remark" style="width:73%"></el-input>
                        </el-row>
                    </div>
                    <span style="color:#F56C6C">此链接记录货源链接，可填写1-5条，非必填。</span>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="edit_blue_point">增加一条记录</el-button>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" v-if="activeName === 'first'" @click="trueLinks('first')">确 定</el-button>
                <el-button type="primary" v-else-if="activeName === 'fourth'" @click="trueLinks('fourth')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="详情" :visible.sync="EditReimbursement4" width="55%" class="dialog">
            <el-form :model="form5" class="form">
                <el-row type="flex">
                    <el-form-item label="国家" :label-width="formLabelWidth">
                        <el-select v-model="form5.country">
                            <el-option
                                v-for="(item, index) in options"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="洲/省" label-width="50px">
                        <el-input v-model="form5.province" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="城市" label-width="50px">
                        <el-input v-model="form5.city" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="县" label-width="40px">
                        <el-input v-model="form5.county" placeholder=""></el-input>
                    </el-form-item>
                </el-row>
                <el-row type="flex">
                    <el-form-item label="收件人" :label-width="formLabelWidth">
                        <el-input v-model="form5.recipient" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="邮编" label-width="50px">
                        <el-input v-model="form5.email" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="电话" label-width="50px">
                        <el-input v-model="form5.phone" placeholder=""></el-input>
                    </el-form-item>
                </el-row>
                <el-form-item label="地址1" :label-width="formLabelWidth">
                    <el-input v-model="form5.Address1" placeholder="" style="width:73%"></el-input>
                </el-form-item>
                <el-form-item label="地址2" :label-width="formLabelWidth">
                    <el-input v-model="form5.Address2" placeholder="" style="width:73%"></el-input>
                </el-form-item>
                <el-form-item label="地址3" :label-width="formLabelWidth">
                    <el-input v-model="form5.Address3" placeholder="" style="width:73%"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button  @click="EditReimbursement4 = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from '../../../api/api/api'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
export default {
    name: 'OrderResourceAllocation',
    components: {
        UploadExcelComponent
    },
    data() {
        return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now()
				},
				shortcuts: [
					{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate()
						},
					},
					{
						text: '上一月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-1)
						},
					},
					{
						text: '上两月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-2)
						},
					},
					{
						text: '上三月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-3)
						},
					},
				],
			},
			str: '',
            title: '',
            AccountId: '',
            CreditCardId: '',
			companyId: '',
            action: Baseurl + "imageController/uploadImage",
            customHeaders: { token: localStorage.getItem("token") },
            note: '',
            fileName: '',
            dialogTitle: '',
            dialogTitle1: '',
            dialogVisible: false,
            dialogFormVisible: false,
            EditReimbursement4: false,
			activeName: 'first',
			total: 0,
			page: 1,
			size: 20,
            formLabelWidth: "110px",
            form5: {
                country: '',
                province: '',
                city: '',
                county: '',
                recipient: '',
                email: '',
                phone: '',
                Address1: '',
                Address2: '',
                Address3: '',
            },
            form4: {
                ReimbursementAmount: '',
                BuyerAccountLevel: '',
                CreditCardLevel: '',
                BuyerAddressClass: '',
                SingleIPlevel: '',
                country: ''
            },
            form3: {
                SingleIPlevel: '',
                country: '',
                ServerType: '',
                PurchaseAccount: '',
                BuyPassword: '',
                DueTime: '',
                IPAddress: '',
                IPPassword: '',
                ReimbursementAmount: ''
            },
            form2: {
                BuyerAddressClass: '',
                country: '',
                province: '',
                city: '',
                county: '',
                recipient: '',
                email: '',
                phone: '',
                Address1: '',
                Address2: '',
                Address3: '',
                ReimbursementAmount: ''
            },
            form1: {
                CreditCardLevel: '',
                country: '',
                CreditCardNumber: '',
                periodValidity: '',
                SecurityCode: '',
                ReimbursementAmount: ''
            },
            form: {
                BuyerAccountLevel: '',
                country: '',
                BuyersAccount: '',
                YourPassword: '',
                AuxiliaryEmail: '',
                BuyerName: '',
                RegistrationTime: '',
                ReimbursementAmount: '',
            },
			iscenter: {
				textAlign: 'center',
				background: '#f8f8f8',
				color: '#232323',
			},
            blue_point: [{ value: "", type: false }],
            EditReimbursement: false,
            EditReimbursement1: false,
            EditReimbursement2: false,
            EditReimbursement3: false,
			load_data: false,
			UserInfo: {},
            arr: [],
            arr1: [],
            arr2: [],
            arr3: [],
            arr4: [],
            summarylist4: [],
            summarylist3: [],
            summarylist: [],
            summarylist1: [],
            summarylist2: [
                { productType: 1 }
            ],
			selectForm: {
                BuyerAccountLevel: '',
                CreditCardLevel: '',
                BuyerAddressClass: '',
                SingleIPLevel: '',
                AccountStatus: '',
                RecipientsState: '',
                timeType: '',
				startTime: '',
				endTime: '',
				input: '',
                country: ''
			},
            departmentList: [],
            groupList: [],
            options: [],
            staffList: [],
            imageData: [],
            imageData1: [],
            imageData2: [],
            imageData3: [],
            imageData4: [],
            country: [
                { value: 0, name: '美国', Referred: 'US' },
                { value: 1, name: '加拿大', Referred: 'CA' },
                { value: 2, name: '墨西哥', Referred: 'MX' },
                { value: 3, name: '英国', Referred: 'GB' },
                { value: 4, name: '德国', Referred: 'DE' },
                { value: 5, name: '法国', Referred: 'FR' },
                { value: 6, name: '意大利', Referred: 'IT' },
                { value: 7, name: '西班牙', Referred: 'ES' },
                { value: 8, name: '荷兰', Referred: 'NL' },
                { value: 9, name: '瑞典', Referred: 'SE' },
                { value: 10, name: '波兰', Referred: 'PL' },
                { value: 11, name: '沙特阿拉伯', Referred: 'SA' },
                { value: 12, name: '阿联酋', Referred: 'AE' },
                { value: 13, name: '日本', Referred: 'JP' },
                { value: 14, name: '澳大利亚', Referred:'AU' },
                { value: 15, name: '新加坡', Referred: 'SG' }

            ],
            List: [],
            List2: [],
            List3: [],
            List4: [],
            AccountList: [],
            IPAddress: '',
            BuyerAddressId: '',
            countryList: {},
            buyerAccountInformationList: []
        }
    },
    created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		this.companyId = this.str.company_id
        this.selectSettings()
        this.getAccountList()
        this.AccountNumber()
    },
    methods: {
        // 导入买家账号
        ImportBuyerAccount(val) {
            for (var i = 0; i < this.imageData4.length; i++) {
                this.arr4.push(this.imageData4[i].data)
            }
            if(val === '导入买家账号') {
                if(this.form4.BuyerAccountLevel === ''){
                    this.$message.error("请选择买家账号等级")
                }else if(this.form4.country === '') {
                    this.$message.error("请选择国家")
                }else if(this.form4.ReimbursementAmount === '') {
                    this.$message.error("请填写报账金额")
                }else {
                    const API =  Baseurl + 'buyerAccountController/batchInsertBuyerAccount'
                    const paramsData = { 
                        companyId: this.companyId,                     // 公司id
                        rankId: this.form4.BuyerAccountLevel,                                  // 买家账号等级
                        countryCode: this.form4.country,                                     // 国家简称
                        reimbursedAmount: this.form4.ReimbursementAmount,                   // 报账金额
                        uploadCertificate: JSON.stringify(this.arr4),                                        // 上传凭证
                        buyerAccountInformationList: this.buyerAccountInformationList
                    }
                    ajaxPost(API,paramsData)
                        .then((res) => {
                            if( res.data.code === 200 ) {
                                this.dialogVisible = false
                                this.$message.success("导入成功")
                                this.getAccountList()
                                this.AccountNumber()
                                this.form4 = {}
                                this.arr4 = []
                                this.imageData4 = []
                            }else {
                                this.$message.error(res.data.data)
                            }
                        })
                    }
            }else if(val === '导入信用卡账号') {
                if(this.form4.CreditCardLevel === ''){
                    this.$message.error("请选择信用卡账号等级")
                }else if(this.form4.country === '') {
                    this.$message.error("请选择国家")
                }else if(this.form4.ReimbursementAmount === '') {
                    this.$message.error("请填写报账金额")
                }else{
                    const API =  Baseurl + 'creditCardAccountController/batchInsertCreditCardAccount'
                    const paramsData = { 
                        companyId: this.companyId,                     // 公司id
                        creditCardAccountLevelId: this.form4.CreditCardLevel,                                  // 信用卡账号等级
                        countryCode: this.form4.country,                                     // 国家简称
                        reimbursedAmount: this.form4.ReimbursementAmount,                   // 报账金额
                        uploadCertificate: JSON.stringify(this.arr4),                                        // 上传凭证
                        creditCardAccountInformationList: this.buyerAccountInformationList
                    }
                    ajaxPost(API,paramsData)
                        .then((res) => {
                            if( res.data.code === 200 ) {
                                this.dialogVisible = false
                                this.$message.success("导入成功")
                                this.getCreditCardList()
                                this.CreditCardNumber()
                                this.form4 = {}
                                this.arr4 = []
                                this.imageData4 = []
                            }else {
                                this.$message.error(res.data.data)
                            }
                        })
                }
            }else if(val === '导入买家地址') {
                if(this.form4.BuyerAddressClass === '') {
                    this.$message.error("请选择买家地址等级")
                }else if(this.form4.country === '') {
                    this.$message.error("请选择国家")
                }else if(this.form4.ReimbursementAmount === '') {
                    this.$message.error("请填写报账金额")
                }else{
                    const API =  Baseurl + 'buyerAddressInformationController/batchInsertBuyerAddress'
                    const paramsData = { 
                        companyId: this.companyId,                     // 公司id
                        buyerAddressLevelId: this.form4.BuyerAddressClass,                                  // 信用卡账号等级
                        countryCode: this.form4.country,                                     // 国家简称
                        reimbursedAmount: this.form4.ReimbursementAmount,                   // 报账金额
                        uploadCertificate: JSON.stringify(this.arr4),                                        // 上传凭证
                        buyerAddressInformationList: this.buyerAccountInformationList
                    }
                    ajaxPost(API,paramsData)
                        .then((res) => {
                            if( res.data.code === 200 ) {
                                this.dialogVisible = false
                                this.$message.success("导入成功")
                                this.getBuyerAddressList()
                                this.BuyerAddressNumber()
                                this.form4 = {}
                                this.arr4 = []
                                this.imageData4 = []
                            }else {
                                this.$message.error(res.data.data)
                            }
                        })
                }
            }else if(val === '导入下单IP地址') {
                if(this.form4.SingleIPlevel === '') {
                    this.$message.error("请选择下单IP地址等级")
                }else if(this.form4.country === '') {
                    this.$message.error("请选择国家")
                } else if(this.form4.ReimbursementAmount === '') {
                    this.$message.error("填写报账金额")
                }
                const API =  Baseurl + 'orderIPAddressController/batchInsertOrderIPAddress'
                const paramsData = { 
                    companyId: this.companyId,                     // 公司id
                    orderIPAddressLevelId: this.form4.SingleIPlevel,                                  // 信用卡账号等级
                    countryCode: this.form4.country,                                     // 国家简称
                    reimbursedAmount: this.form4.ReimbursementAmount,                   // 报账金额
                    uploadCertificate: JSON.stringify(this.arr4),                                        // 上传凭证
                    orderIPAddressInformationList: this.buyerAccountInformationList
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.dialogVisible = false
                            this.$message.success("导入成功")
                            this.getIPAddressList()
                            this.IPAddressNumber()
                            this.form4 = {}
                            this.arr4 = []
                            this.imageData4 = []
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }
        },
        // 查询各国买家账号数量
        AccountNumber() {
            const API =  Baseurl + 'buyerAccountController/selectBuyerAccountCount'
            const paramsData = { 
                companyId: this.companyId,                     // 公司id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.countryList = res.data.data
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 查询各国信用卡账号数量   
        CreditCardNumber() {
            const API =  Baseurl + 'creditCardAccountController/selectCreditCardAccountCount'
            const paramsData = { 
                companyId: this.companyId,                     // 公司id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.countryList = res.data.data
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 查询各国买家地址数量   
        BuyerAddressNumber() {
            const API =  Baseurl + 'buyerAddressInformationController/selectBuyerAddressCount'
            const paramsData = { 
                companyId: this.companyId,                     // 公司id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.countryList = res.data.data
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 查询各国下单IP地址数量   
        IPAddressNumber() {
            const API =  Baseurl + 'orderIPAddressController/selectOrderIPAddressCount'
            const paramsData = { 
                companyId: this.companyId,                     // 公司id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.countryList = res.data.data
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        costReconciliation(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate()
            this.form1.periodValidity = datetime;
        },
        DueTime(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate()
            this.form3.DueTime = datetime;
        },
        RegistrationTime(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate()
            this.form.RegistrationTime = datetime;
        },
        Search(val) {
            if(val === '1') {
                this.getAccountList()
            }else if(val === '2'){
                this.getCreditCardList()
            }else if(val === '3') {
                this.getBuyerAddressList()
            }else if(val === '4') {
                this.getIPAddressList()
            }
        },
        // 分页查询买家账号信息
        getAccountList() {
            this.load_data = true
            const API =  Baseurl + 'buyerAccountController/selectBuyerAccountList'
            const paramsData = {             // 类型
                timeType: this.selectForm.timeType,
                companyId: this.companyId,                     // 公司id
                beginDate: this.selectForm.startTime,
                endDate: this.selectForm.endDate,
                searchString: this.selectForm.input,
                rankId: this.selectForm.BuyerAccountLevel,
                countryCode: this.selectForm.country,
                buyerAccountAccountStatus: this.selectForm.AccountStatus,
                buyerAccountRequisitionStatus: this.selectForm.RecipientsState,
                page: this.page,
                size: this.size
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    this.load_data = false
                    if( res.data.code === 200 ) {
                        this.summarylist4 = res.data.data.list
                        this.total = res.data.data.total
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 分页查询信用卡账号信息
        getCreditCardList() {
            this.load_data = true
            const API =  Baseurl + 'creditCardAccountController/selectCreditCardAccountList'
            const paramsData = {             // 类型
                timeType: this.selectForm.timeType,
                companyId: this.companyId,                     // 公司id
                beginDate: this.selectForm.startTime,
                endDate: this.selectForm.endDate,
                searchString: this.selectForm.input,
                creditCardAccountLevel: this.selectForm.CreditCardLevel,
                countryCode: this.selectForm.country,
                buyerAccountAccountStatus: this.selectForm.AccountStatus,
                buyerAccountRequisitionStatus: this.selectForm.RecipientsState,
                page: this.page,
                size: this.size
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    this.load_data = false
                    if( res.data.code === 200 ) {
                        this.summarylist1 = res.data.data.list
                        this.total = res.data.data.total
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 分页查询买家地址信息
        getBuyerAddressList() {
            this.load_data = true
            const API =  Baseurl + 'buyerAddressInformationController/selectBuyerAddressList'
            const paramsData = {           
                companyId: this.companyId,                     // 公司id
                beginDate: this.selectForm.startTime,
                endDate: this.selectForm.endDate,
                searchString: this.selectForm.input,
                buyerAddressLevel: this.selectForm.BuyerAddressClass,
                countryCode: this.selectForm.country,
                buyerAccountAccountStatus: this.selectForm.AccountStatus,
                buyerAccountRequisitionStatus: this.selectForm.RecipientsState,
                page: this.page,
                size: this.size
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    this.load_data = false
                    if( res.data.code === 200 ) {
                        this.summarylist2 = res.data.data.list
                        this.total = res.data.data.total
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 分页查询下单IP地址信息
        getIPAddressList() {
            this.load_data = true
            const API =  Baseurl + 'orderIPAddressController/selectOrderIPAddressList'
            const paramsData = {           
                companyId: this.companyId,                     // 公司id
                beginDate: this.selectForm.startTime,
                endDate: this.selectForm.endDate,
                searchString: this.selectForm.input,
                orderIPAddressLevelId: this.selectForm.SingleIPLevel,
                countryCode: this.selectForm.country,
                buyerAccountAccountStatus: this.selectForm.AccountStatus,
                buyerAccountRequisitionStatus: this.selectForm.RecipientsState,
                page: this.page,
                size: this.size
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    this.load_data = false
                    if( res.data.code === 200 ) {
                        this.summarylist3 = res.data.data.list
                        this.total = res.data.data.total
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 新增买家账号信息
        EditbankCard() {
            if(this.form.BuyerAccountLevel === undefined){
                this.$message.error("请选择买家账号等级")
            }else if(this.form.country === undefined) {
                this.$message.error("请选择国家")
            }else if(this.form.BuyersAccount === undefined) {
                this.$message.error("请填写买家账号")
            }else if(this.form.BuyerName === undefined) {
                this.$message.error("请填写买家名称")
            }else if(this.form.ReimbursementAmount === undefined) {
                this.$message.error("请填写报账金额")
            }else {
                for (var i = 0; i < this.imageData.length; i++) {
                    this.arr.push(this.imageData[i].data)
                }
                const API =  Baseurl + 'buyerAccountController/insertBuyerAccount'
                const paramsData = {
                    rankId: this.form.BuyerAccountLevel,                                  // 买家账号等级
                    countryCode: this.form.country,                                     // 国家简称
                    buyerAccount: this.form.BuyersAccount,                              // 买家账号
                    emailPassword: this.form.YourPassword,                              // 邮箱密码
                    recoveryEmail: this.form.AuxiliaryEmail,                            // 辅助邮箱
                    buyerName: this.form.BuyerName,                                     // 买家名称
                    registrationTime: this.form.RegistrationTime,                       // 注册时间
                    reimbursedAmount: this.form.ReimbursementAmount,                    // 报账金额
                    uploadCertificate: JSON.stringify(this.arr),                                        // 上传凭证
                    companyId: this.companyId                                           // 公司id
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.EditReimbursement = false
                            this.getAccountList()
                            this.AccountNumber()
                            this.form = {}
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }
        },
        // 新增信用卡账号信息
        EditbankCard1() {
            if(this.form1.CreditCardLevel === undefined){
                this.$message.error("请选择信用卡账号等级")
            }else if(this.form1.country === undefined) {
                this.$message.error("请选择国家")
            }else if(this.form1.CreditCardNumber === undefined) {
                this.$message.error("请填写信用卡账号")
            }else if(this.form1.ReimbursementAmount === undefined) {
                this.$message.error("请填写报账金额")
            } else {
                for (var i = 0; i < this.imageData1.length; i++) {
                this.arr1.push(this.imageData1[i].data)
                }
                const API =  Baseurl + 'creditCardAccountController/insertCreditCardAccount'
                const paramsData = {
                    creditCardAccountLevelId: this.form1.CreditCardLevel,                                  // 信用卡账号等级
                    countryCode: this.form1.country,                                     // 国家简称
                    creditCardAccount: this.form1.CreditCardNumber,                              // 信用卡账号
                    securityCode: this.form1.SecurityCode,                              // 安全码
                    expirationDate: this.form1.periodValidity,                            // 有效期
                    companyId: this.companyId,                                           // 公司id
                    reimbursedAmount: this.form1.ReimbursementAmount,                    // 报账金额
                    uploadCertificate: JSON.stringify(this.arr1),                        // 上传凭证
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.EditReimbursement1 = false
                            this.getCreditCardList()
                            this.CreditCardNumber()
                            this.form1 = {}
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }
        },
        // 新增买家地址信息
        EditbankCard2() {
            if(this.form2.BuyerAddressClass === undefined) {
                this.$message.error("请选择买家地址等级")
            }else if(this.form2.country === undefined) {
                this.$message.error("请选择国家")
            }else if(this.form2.province === undefined && this.form2.city === undefined && this.form2.county === undefined) {
                this.$message.error("州/省、城市、县最少填写一项")
            }else if(this.form2.recipient === undefined) {
                this.$message.error("请填写收件人")
            }else if(this.form2.email === undefined) {
                this.$message.error("请填写邮编")
            }else if(this.form2.phone === undefined) {
                this.$message.error("请填写电话")
            }else if(this.form2.Address1 === undefined && this.form2.Address2 === undefined && this.form2.Address3 === undefined) {
                this.$message.error("最少填写一个地址")
            }else if(this.form2.ReimbursementAmount === undefined) {
                this.$message.error("请填写报账金额")
            }else {
                for (var i = 0; i < this.imageData2.length; i++) {
                this.arr2.push(this.imageData2[i].data)
                }
                const API =  Baseurl + 'buyerAddressInformationController/insertBuyerAddress'
                const paramsData = {
                    companyId: this.companyId,                                           // 公司id
                    buyerAddressLevelId: this.form2.BuyerAddressClass,                                  // 买家地址等级
                    countryCode: this.form2.country,                                     // 国家简称
                    stateOrRegion: this.form2.province,                              // 洲或省
                    city: this.form2.city,                              // 城市
                    county: this.form2.county,                            // 县
                    district: '',                                           // 区
                    municipality: '',                    // 自治市
                    recipient: this.form2.recipient,                        // 收件人
                    postalCode: this.form2.email,                           // 邮编
                    phone: this.form2.phone,                           // 电话
                    addressLine1: this.form2.Address1,                        // 地址1
                    addressLine2: this.form2.Address2,                           // 地址2
                    addressLine3: this.form2.Address3,                           // 地址3
                    reimbursedAmount: this.form2.ReimbursementAmount,               // 报账金额
                    uploadCertificate: JSON.stringify(this.arr2),                        // 上传凭证
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.EditReimbursement2 = false
                            this.getBuyerAddressList()
                            this.BuyerAddressNumber()
                            this.form2 = {}
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }
        },
        // 新增下单IP地址信息
        EditbankCard3() {
            if(this.form3.SingleIPlevel === undefined) {
                this.$message.error("请选择下单IP地址等级")
            }else if(this.form3.country === undefined) {
                this.$message.error("请选择国家")
            } else if(this.form3.PurchaseAccount === undefined) {
                this.$message.error("填写购买账号")
            } else if(this.form3.IPAddress === undefined) {
                this.$message.error("填写IP账号")
            } else if(this.form3.ReimbursementAmount === undefined) {
                this.$message.error("填写报账金额")
            }else {
                for (var i = 0; i < this.imageData3.length; i++) {
                this.arr3.push(this.imageData3[i].data)
                }
                const API =  Baseurl + 'orderIPAddressController/insertOrderIPAddress'
                const paramsData = {
                    companyId: this.companyId,                                           // 公司id
                    orderIPAddressLevelId: this.form3.SingleIPlevel,                                  // 下单IP地址等级
                    countryCode: this.form3.country,                                     // 国家简称
                    serverType: this.form3.ServerType,                              // 服务器种类
                    purchaseAccount: this.form3.PurchaseAccount,                              // 购买账号
                    purchasePassword: this.form3.BuyPassword,                            // 购买密码
                    expirationDate: this.form3.DueTime,                        // 有效期
                    address: this.form3.IPAddress,                           // IP地址
                    password: this.form3.IPPassword,                           // IP密码
                    reimbursedAmount: this.form3.ReimbursementAmount,               // 报账金额
                    uploadCertificate: JSON.stringify(this.arr3),                        // 上传凭证
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.EditReimbursement3 = false
                            this.getIPAddressList()
                            this.IPAddressNumber()
                            this.form3 = {}
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }
        },
        selectSettings() {
            const API =  Baseurl + 'buyerAccountSettingController/selectBuyerAccountSettings'
            const paramsData = {
                companyId: 1                                       // 公司id
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.List = res.data.data.buyerAccountSetting
                        this.List2 = res.data.data.creditCardSetting
                        this.List3 = res.data.data.buyerAddress
                        this.List4 = res.data.data.orderIPAddressSetting
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 删除买家账号
        delAccount(row) {
            this.$confirm('确定要删除该项吗', '提示').then(() => {
                const API = Baseurl + 'buyerAccountController/deleteBuyerAccount'
                const paramsData = { id: row.id }
                ajaxPost(API, paramsData).then(res => {
                    const { code } = res.data
                    if (code === 200) {
                        this.getAccountList()
                        this.AccountNumber()
                        this.$message.success('操作成功')
                    }else {
						this.$message.error(res.data.data)
					}
                })
            })
        },
        // 删除信用卡账号
        delCreditCardList(row) {
            this.$confirm('确定要删除该项吗', '提示').then(() => {
                const API = Baseurl + 'creditCardAccountController/deleteCreditCardAccount'
                const paramsData = { id: row.id }
                ajaxPost(API, paramsData).then(res => {
                    const { code } = res.data
                    if (code === 200) {
                        this.getCreditCardList()
                        this.CreditCardNumber()
                        this.$message.success('操作成功')
                    }else {
						this.$message.error(res.data.data)
					}
                })
            })
        },
        // 删除买家地址
        delBuyerAddressList(row) {
            this.$confirm('确定要删除该项吗', '提示').then(() => {
                const API = Baseurl + 'buyerAddressInformationController/deleteBuyerAddress'
                const paramsData = { id: row.id }
                ajaxPost(API, paramsData).then(res => {
                    const { code } = res.data
                    if (code === 200) {
                        this.getBuyerAddressList()
                        this.BuyerAddressNumber()
                        this.$message.success('操作成功')
                    }else {
						this.$message.error(res.data.data)
					}
                })
            })
        },
        // 删除下单IP地址
        delIPAddressList(row) {
            this.$confirm('确定要删除该项吗', '提示').then(() => {
                const API = Baseurl + 'orderIPAddressController/deleteOrderIPAddress'
                const paramsData = { id: row.id }
                ajaxPost(API, paramsData).then(res => {
                    const { code } = res.data
                    if (code === 200) {
                        this.getIPAddressList()
                        this.IPAddressNumber()
                        this.$message.success('操作成功')
                    }else {
						this.$message.error(res.data.data)
					}
                })
            })
        },
        // 修改买家账号
        updateAccount() {
            for (var i = 0; i < this.imageData.length; i++) {
                this.arr.push(this.imageData[i].data)
            }
            const API =  Baseurl + 'buyerAccountController/updateBuyerAccount'
            const paramsData = {
                id: this.AccountId,
                rankId: this.form.BuyerAccountLevel,                                  // 买家账号等级
                countryCode: this.form.country,                            // 国家简称
                buyerAccount: this.form.BuyersAccount,                           // 买家账号
                emailPassword: this.form.YourPassword,                          // 邮箱密码
                recoveryEmail: this.form.AuxiliaryEmail,                          // 辅助邮箱
                buyerName: this.form.BuyerName,                              // 买家名称
                reimbursedAmount: this.form.ReimbursementAmount,                       // 报账金额
                uploadCertificate: JSON.stringify(this.arr),                      // 上传凭证
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.EditReimbursement = false
                        this.getAccountList()
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 修改信用卡账号
        updateAccount1() {
            for (var i = 0; i < this.imageData1.length; i++) {
                this.arr1.push(this.imageData1[i].data)
            }
            const API =  Baseurl + 'creditCardAccountController/updateCreditCardAccount'
            const paramsData = {
                id: this.CreditCardId,
                creditCardAccountLevelId: this.form1.CreditCardLevel,                                  // 信用卡账号等级id
                countryCode: this.form1.country,                            // 国家简称
                creditCardAccount: this.form1.CreditCardNumber,                           // 信用卡账号
                securityCode: this.form1.SecurityCode,                          // 安全码
                expirationDate: this.form1.periodValidity,                          // 有效期
                reimbursedAmount: this.form1.ReimbursementAmount,                       // 报账金额
                uploadCertificate: JSON.stringify(this.arr1),                      // 上传凭证
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.EditReimbursement1 = false
                        this.getCreditCardList()
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 修改买家地址
        updateAccount2() {
            for (var i = 0; i < this.imageData2.length; i++) {
            this.arr2.push(this.imageData2[i].data)
            }
            const API =  Baseurl + 'buyerAddressInformationController/updateBuyerAddress'
            const paramsData = {
                id: this.BuyerAddressId,
                buyerAddressLevelId: this.form2.BuyerAddressClass,                                  // 买家地址等级
                countryCode: this.form2.country,                                     // 国家简称
                stateOrRegion: this.form2.province,                              // 洲或省
                city: this.form2.city,                              // 城市
                county: this.form2.county,                            // 县
                district: '',                                           // 区
                municipality: '',                    // 自治市
                recipient: this.form2.recipient,                        // 收件人
                postalCode: this.form2.email,                           // 邮编
                phone: this.form2.phone,                           // 电话
                addressLine1: this.form2.Address1,                        // 地址1
                addressLine2: this.form2.Address2,                           // 地址2
                addressLine3: this.form2.Address3,                           // 地址3
                reimbursedAmount: this.form2.ReimbursementAmount,           // 报账金额
                uploadCertificate: JSON.stringify(this.arr2),                        // 上传凭证
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.EditReimbursement2 = false
                        this.getBuyerAddressList()
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 修改下单ip地址
        updateAccount3() {
            for (var i = 0; i < this.imageData3.length; i++) {
            this.arr3.push(this.imageData3[i].data)
            }
            const API =  Baseurl + 'orderIPAddressController/updateOrderIPAddress'
            const paramsData = {
                id: this.IPAddress,
                orderIPAddressLevelId: this.form3.SingleIPlevel,                                  // 买家地址等级
                countryCode: this.form3.country,                                     // 国家简称
                serverType: this.form3.ServerType,                              // 洲或省
                purchaseAccount: this.form3.PurchaseAccount,                              // 城市
                purchasePassword: this.form3.BuyPassword,                            // 县
                expirationDate: this.form3.DueTime,                        // 收件人
                address: this.form3.IPAddress,                           // 邮编
                password: this.form3.IPPassword,                           // 电话
                reimbursedAmount: this.form3.ReimbursementAmount,           // 报账金额
                uploadCertificate: JSON.stringify(this.arr3),                        // 上传凭证
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.EditReimbursement3 = false
                        this.getIPAddressList()
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        // 重置
        searchReset(val) {
			this.selectForm.BuyerAccountLevel = ''
			this.selectForm.CreditCardLevel = ''
			this.selectForm.BuyerAddressClass = ''
			this.selectForm.SingleIPLevel = ''
			this.selectForm.AccountStatus = ''
			this.selectForm.RecipientsState = ''
			this.selectForm.startTime = ''
			this.selectForm.endTime = ''
			this.selectForm.input = ''
			this.selectForm.timeType = ''
			this.selectForm.country = ''

            if(val === '1') {
                this.getAccountList()
            }else if(val === '2'){
                this.getCreditCardList()
            }else if(val === '3') {
                this.getBuyerAddressList()
            }else if(val === '4') {
                this.getIPAddressList()
            }
        },
        //图片上传
        handleAvatarSuccess(file, fileList) {
            this.imageData.push(file)
        },
        handleAvatarSuccess1(file, fileList) {
            this.imageData1.push(file)
        },
        handleAvatarSuccess2(file, fileList) {
            this.imageData2.push(file)
        },
        handleAvatarSuccess3(file, fileList) {
            this.imageData3.push(file)
        },
        handleAvatarSuccess4(file, fileList) {
            this.imageData4.push(file)
        },
        handlePictureCardPreview(file) {

        },
        //删除要上传的图片
        handleRemove(file, fileList) {
            this.imageData = []
            for (var i = 0; i < fileList.length; i++) {
                this.imageData.push(fileList[i].response)
            }
            this.arr = this.imageData
        },
        handleRemove1(file, fileList) {
            this.imageData1 = []
            for (var i = 0; i < fileList.length; i++) {
                this.imageData1.push(fileList[i].response)
            }
            this.arr1 = this.imageData1
        },
        handleRemove2(file, fileList) {
            this.imageData2 = []
            for (var i = 0; i < fileList.length; i++) {
                this.imageData2.push(fileList[i].response)
            }
            this.arr2 = this.imageData2
        },
        handleRemove3(file, fileList) {
            this.imageData3 = []
            for (var i = 0; i < fileList.length; i++) {
                this.imageData3.push(fileList[i].response)
            }
            this.arr3 = this.imageData3
        },
        handleRemove4(file, fileList) {
            this.imageData4 = []
            for (var i = 0; i < fileList.length; i++) {
                this.imageData4.push(fileList[i].response)
            }
        },
        // 添加链接
        edit_blue_point(index, method) {
            if (this.blue_point.length < 5) {
                const param = {
                    value: "",
                    type: true,
                };
                this.blue_point.push(param);
            } else {
                this.$message("此链接记录货源链接最多5条字段");
            }
        },
        // 删除链接
        edit_blue_del(item, index) {
            this.blue_point.splice(index, 1);
        },
        handleSuccess( val ) {
            if(this.activeName === 'first') {
                this.buyerAccountInformationList = val.results.map(item => ({
                    buyerAccount: item.买家账号,
                    emailPassword: item.邮箱密码,
                    recoveryEmail: item.辅助密码,
                    buyerName: item.买家名称,
                    registrationTime: item.注册时间.replace(/\./g, '-')
                }))
                this.buyerAccountInformationList.every(item => {
                    if(!item.buyerAccount) {
                        this.$message.error('请填写买家账号')
                    }else if(!item.buyerName) {
                        this.$message.error('请填写买家名称')
                    }else{
                        this.fileName = val.fileName
                    }
                })
            }else if(this.activeName === 'second') {
                this.buyerAccountInformationList = val.results.map(item => ({
                    creditCardAccount: item.信用卡账号,
                    securityCode: item.安全码,
                    expirationDate: item.有效期.toString().substring(0,4)
                                    + '-' + 
                                    item.有效期.toString().substring(5,7) 
                                    + '-' + 
                                    new Date( item.有效期.toString().substring(0,4), item.有效期.toString().substring(5,7), 0 ).getDate()
                }))
                this.buyerAccountInformationList.every(item => {
                    if(!item.creditCardAccount) {
                        this.$message.error('请填写信用卡账号')
                    }else{
                        this.fileName = val.fileName
                    }
                })
            }else if(this.activeName === 'third') {
                this.buyerAccountInformationList = val.results.map(item => ({
                    stateOrRegion: item.州或省,
                    city: item.城市,
                    county: item.县,
                    district: item.区,
                    municipality: item.自治市,
                    recipient: item.收件人,
                    postalCode: item.邮编号码,
                    phone: item.电话,
                    addressLine1: item.地址一,
                    addressLine2: item.地址二,
                    addressLine3: item.地址三
                }))
                this.buyerAccountInformationList.every(item => {
                    if(!item.stateOrRegion && !item.city && !item.county){
                        this.$message.error("州/省、城市、县最少填写一项")
                    }else if(!item.recipient){
                        this.$message.error("请填写收件人")
                    }else if(!item.postalCode){
                        this.$message.error("请填写邮编")
                    }else if(!item.phone){
                        this.$message.error("请填写电话")
                    }else if(!item.addressLine1 && !item.addressLine2 && !item.addressLine3){
                        this.$message.error("最少填写一个地址")
                    }else{
                        this.fileName = val.fileName
                    }
                })
            }else if(this.activeName === 'fourth') {
                this.buyerAccountInformationList = val.results.map(item => ({
                    purchaseAccount: item.购买账号,
                    purchasePassword: item.购买密码,
                    address: item.IP地址,
                    password: item.IP密码,
                    expirationDate: item.到期时间.replace(/\./g, '-')
                }))
                this.buyerAccountInformationList.every(item => {
                    if(!item.purchaseAccount){
                        this.$message.error("请填写购买账号")
                    }else if(!item.address){
                        this.$message.error("请填写IP地址")
                    }else{
                        this.fileName = val.fileName
                    }
                })
            }
        },
        handleResources(title) {
            this.dialogFormVisible = true
            if(title == 'first') {
                this.dialogTitle1 = '买家账号资源链接'
                this.selectAccountResourceLinks()
            }else if(title == 'fourth') {
                this.dialogTitle1 = '下单IP地址资源链接'
                this.selectIpAddressResources()
            }
        },
        selectAccountResourceLinks(){
            const API =  Baseurl + 'accountResourceLinkController/selectAccountResourceLinks'
            const paramsData = {
                companyId: this.companyId
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.blue_point = res.data.data
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        selectIpAddressResources(){
            const API =  Baseurl + 'orderIpAddressResourceController/selectOrderIpAddressResources'
            const paramsData = {
                companyId: this.companyId
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if( res.data.code === 200 ) {
                        this.blue_point = res.data.data
                    }else {
						this.$message.error(res.data.data)
					}
                })
        },
        trueLinks(val) {
            var arr = []
            for(var i = 0; i < this.blue_point.length; i++) {
                var obj = {
                    resourceLink: this.blue_point[i].resourceLink,
                    remark: this.blue_point[i].remark
                }
                arr.push(obj)
            }
            if(val === 'first'){
                const API =  Baseurl + 'accountResourceLinkController/updateAccountResourceLink'
                const paramsData = {
                    companyId: this.companyId,
                    accountResourceLinkList: arr
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.dialogFormVisible = false
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }else if(val === 'fourth') {
                const API =  Baseurl + 'orderIpAddressResourceController/updateOrderIpAddressResource'
                const paramsData = {
                    companyId: this.companyId,
                    orderIpAddressResourceList: arr
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.dialogFormVisible = false
                        }else{
                            this.$message.error(res.data.data);
                        }
                    })
            }
        },
        handleImport(title) {
            this.fileName = ''
            this.dialogVisible = true
            this.title = title
            if(title == 'first') {
                this.dialogTitle = '导入买家账号'
            }else if(title == 'second') {
                this.dialogTitle = '导入信用卡账号'
            }else if(title == 'third') {
                this.dialogTitle = '导入买家地址'
            }else{
                this.dialogTitle = '导入下单IP地址'
            }
        },
        handleBack(val,row) {
            if(val === 'first') {
                const API =  Baseurl + 'buyerAccountController/recycleBuyerAccount'
                const paramsData = {
                    id: row.id,
                    buyerAccountAccountStatus: '3'
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.getAccountList()
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }else if(val === 'second') {
                const API =  Baseurl + 'creditCardAccountController/recycleCreditCardAccount'
                const paramsData = {
                    id: row.id,
                    buyerAccountAccountStatus: '3'
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.getCreditCardList()
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }else if(val === 'third') {
                const API =  Baseurl + 'buyerAddressInformationController/recycleBuyerAddress'
                const paramsData = {
                    id: row.id,
                    buyerAddressAccountStatus: '3'
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.getBuyerAddressList()
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }else if(val === 'fourth') {
                const API =  Baseurl + 'orderIPAddressController/recycleOrderIPAddress'
                const paramsData = {
                    id: row.id,
                    orderIPAccountStatus: '3'
                }
                ajaxPost(API,paramsData)
                    .then((res) => {
                        if( res.data.code === 200 ) {
                            this.getIPAddressList()
                        }else {
                            this.$message.error(res.data.data)
                        }
                    })
            }
        },
        downloadTemplate() {
            const aEle = document.createElement('a')
            if(this.activeName === 'first') {
                aEle.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E4%B9%B0%E5%AE%B6%E8%B4%A6%E5%8F%B7%E6%A8%A1%E6%9D%BF.xlsx'
            }else if(this.activeName === 'second') {
                aEle.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E4%BF%A1%E7%94%A8%E5%8D%A1%E6%A8%A1%E6%9D%BF.xlsx'
            }else if(this.activeName === 'third') {
                aEle.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E4%B9%B0%E5%AE%B6%E5%9C%B0%E5%9D%80%E6%A8%A1%E6%9D%BF.xlsx'
            }else if(this.activeName === 'fourth') {
                aEle.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E4%B8%8B%E5%8D%95IP%E5%9C%B0%E5%9D%80%E6%A8%A1%E6%9D%BF.xlsx'
            }
            aEle.click()
            this.$message.success('正在下载...')
        },
		handleClick(tab, event) {
            if(tab.name === 'first') {
                this.getAccountList()
                this.AccountNumber()
            }else if(tab.name === 'second') {
                this.getCreditCardList()
                this.CreditCardNumber()
            }else if(tab.name === 'third') {
                this.getBuyerAddressList()
                this.BuyerAddressNumber()
            } else if(tab.name === 'fourth') {
                this.getIPAddressList()
                this.IPAddressNumber()
            }
		},
        edit(row) {
            this.AccountId = row.id,
            this.EditReimbursement = true;
            this.arr = []
            if(row === '1'){
                this.form = { status: '0' }
            }else {
                this.form.BuyerAccountLevel = row.rankId
                this.form.country = row.countryCode
                this.form.BuyersAccount = row.buyerAccount
                this.form.YourPassword = row.emailPassword
                this.form.AuxiliaryEmail  = row.recoveryEmail
                this.form.BuyerName = row.buyerName
                this.form.RegistrationTime = row.registrationTime
                this.form.ReimbursementAmount = row.reimbursedAmount
                this.form.status = '1'
                this.arr = row.uploadCertificates.map(item => {
                    return {
                        name: item,
                        url: item
                    }
                })
}
        },
        edit1(row) {
            this.CreditCardId = row.id,
            this.EditReimbursement1 = true;
            this.arr1 = []
            if(row === '1') {
                this.form1 = { status: '0' }
            }else {
                this.form1.CreditCardLevel = row.creditCardAccountLevelId
                this.form1.country = row.countryCode
                this.form1.province = row.creditCardAccount
                this.form1.periodValidity = row.expirationDate
                this.form1.SecurityCode = row.creditCardReceiptStatus
                this.form1.ReimbursementAmount = row.reimbursedAmount
                this.form1.status = '1'
                this.arr1 = row.uploadCertificates.map(item => {
                    return {
                        name: item,
                        url: item
                    }
                })
            }
        },
        edit2(row) {
            this.BuyerAddressId = row.id,
            this.EditReimbursement2 = true;
            this.arr2 = []
            if(row === '1') {
                this.form2 = { status: '0' }
            }else {
                this.form2.BuyerAddressClass = row.buyerAddressLevelId
                this.form2.country = row.countryCode
                this.form2.province = row.stateOrRegion
                this.form2.city = row.city
                this.form2.county = row.county
                this.form2.recipient = row.recipient
                this.form2.email = row.postalCode
                this.form2.phone = row.phone
                this.form2.Address1 = row.addressLine1
                this.form2.Address2 = row.addressLine2
                this.form2.Address3 = row.addressLine3
                this.form2.ReimbursementAmount = row.reimbursedAmount
                this.form2.status = '1'
                this.arr2 = row.uploadCertificates.map(item => {
                    return {
                        name: item,
                        url: item
                    }
                })
            }
        },
        edit3(row) {
            this.IPAddress = row.id,
            this.EditReimbursement3 = true;
            this.arr3 = []
            if(row === '1'){
                this.form3 = { status: '0' }
            } else {
                this.form3.SingleIPlevel = row.orderIPAddressLevelId
                this.form3.country = row.countryCode
                this.form3.ServerType = row.serverType
                this.form3.PurchaseAccount = row.purchaseAccount
                this.form3.BuyPassword = row.purchasePassword
                this.form3.DueTime = row.expirationDate
                this.form3.IPAddress = row.address
                this.form3.IPPassword = row.password
                this.form3.ReimbursementAmount = row.reimbursedAmount
                this.form3.status = '1'
                this.arr3 = row.uploadCertificates.map(item => {
                    return {
                        name: item,
                        url: item
                    }
                })
            }
        },
        handleSizeChange(val) {
			this.size = val
            if(this.activeName === 'first'){
                this.getAccountList()
            }else if(this.activeName === 'second'){
                this.getCreditCardList()
            }else if(this.activeName === 'third') {
                this.getBuyerAddressList()
            }else if(this.activeName === 'fourth') {
                this.getIPAddressList()
            }
		},
		handleCurrentChange(val) {
			this.page = val
            if(this.activeName === 'first'){
                this.getAccountList()
            }else if(this.activeName === 'second'){
                this.getCreditCardList()
            }else if(this.activeName === 'third') {
                this.getBuyerAddressList()
            }else if(this.activeName === 'fourth') {
                this.getIPAddressList()
            }
		},
    }
}
</script>
<style lang="scss" scoped>
.OrderResourceAllocation{
	width: 98%;
	// background: #F7F7F7;
	padding-bottom: 72px;
	.summary_bag {
		width: 98%;
		margin: auto;
		.summary_complete_bag {
            margin-top: 20px;
			overflow: hidden;
            .span-box{
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 15px;
                .el-icon-question{
                    font-size: 14px;
                }
            }
		}
		.summary_pagenum {
			width: 99.6%;
			margin-bottom: 10px;
			overflow: hidden;
			background: #f5f5f5;
            display: flex;
            justify-content: flex-end;
            padding: 5px;
		}
		.summary_pagenum1 {
			width: 99.6%;
			margin-bottom: 10px;
			overflow: hidden;
			background: #f5f5f5;
            display: flex;
            justify-content: space-between;
            padding: 5px;
		}
		.summary_content {
			width: 100%;
			border: 1px solid #eee;
			overflow: hidden;
		}
		.summary_pagenum_block {
			width: 1790px;
			padding: 20px;
			position: fixed;
			right: 0;
			bottom: 0;
			background: #fff;
			z-index: 999;
			.el-pagination {
				display: flex;
				justify-content: center;
			}
		}
        .dialog{
            .form {
                .el-input {
                    width: 200px;
                }
                .el-select {
                    width: 200px;
                }
                .el-form-item{
                    margin-bottom: 15px;
                }
            }
        }
	}
}
</style>